export default __webpack_public_path__ + "static/media/ic_pin.982c95ba.svg";